var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M13.009 13.987V8.934h-1.956v5.053h1.956zm0 4.016v-1.962h-1.956v1.962h1.956zM2.988 20.962L12.016 3l9.025 17.962H2.988z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }